import HeaderCustomized from "../components/imgBackground/HeaderCustomized.js";
import { Auth } from "aws-amplify"
import { useEffect, useState } from "react";

import { motion } from "framer-motion";
import {
Building2,
School,
Layers,
Tag,
UserCircle,
AtSign,
IdCard,
} from "lucide-react";


const InfoRow = ({ icon: Icon, label, value }) => (
    <div className="flex items-center justify-between border-b border-gray-100 py-3 dark:border-white/10">
        <div className="flex items-center gap-3">
            <div className="rounded-lg p-2 bg-blue-50 dark:bg-cyan-900/30 ring-1 ring-black/5 dark:ring-white/10">
                <Icon className="h-5 w-5 text-blue-600 dark:text-cyan-300" aria-hidden />
            </div>
            <span className="font-medium text-gray-700 dark:text-gray-200">{label} </span>
        </div>
        <span className="text-sm text-gray-900 dark:text-gray-100 text-right truncate max-w-[60%]">
        {value || "—"}
        </span>
    </div>
);

export default function Profile({currentuser, title = "Perfil del Usuario"}) {

    const [user, setUser] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(()=>{
        function loadUser(){
            return Auth.currentUserInfo();
        }

        async function onLoad(){
            try{
                const user = await loadUser();
                setUser(user)
            }catch (e){
                alert(e)
            }
            setIsLoading(false)
        }
        onLoad();
    },[]);
    
    var datagrado = '#'
    console.log(currentuser.attributes)
    if(user!=[]){
        if(user.attributes != null)
            datagrado = user.attributes['custom:Grado']
    }


    const data = {
        ugel: currentuser?.attributes?.["zoneinfo"],
        institucion: currentuser?.attributes?.["custom:Colegio"],
        nivel: currentuser?.attributes?.["custom:Nivel"],
        categoria: currentuser?.attributes?.["custom:categoria_usuario"],
        usuario: currentuser?.username,
        nombre: currentuser?.attributes?.["name"],
        nickname: currentuser?.attributes?.["nickname"],
        apellido: currentuser?.attributes?.["family_name"],
    };

    const hasData = Object.values(data).some(Boolean);


return (
    <>
    <HeaderCustomized nivel_estudiante={currentuser.attributes['custom:Nivel']} grade_estudiante={currentuser.attributes['custom:grade']} especialidad_usuario={currentuser.attributes['custom:especialidad']}  categoria_usuario={currentuser.attributes['custom:categoria_usuario']}  grado_estudiante={currentuser.attributes['custom:Grado']} colegio_usuario={currentuser.attributes['custom:Colegio']} username={currentuser.attributes['given_name']} zoneinfo={currentuser.attributes['zoneinfo']} ></HeaderCustomized>
    
    <div className="mx-auto mt-12 max-w-2xl p-4">
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="rounded-2xl border border-gray-100 bg-white p-6 shadow-lg ring-1 ring-black/5 dark:border-white/10 dark:bg-gray-900 dark:ring-white/10"
        >
        <div className="mb-4 flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
            {data.categoria && (
            <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-semibold uppercase text-blue-700 dark:bg-cyan-900/40 dark:text-cyan-300">
            {data.categoria}
            </span>
            )}
        </div>


        <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
            Información general del usuario actual.
        </p>

        {
        hasData ? (
            <div className="space-y-2">
                <InfoRow icon={Building2} label="UGEL" value={data.ugel} />
                <InfoRow icon={School} label="Institución" value={data.institucion} />
                <InfoRow icon={Layers} label="Nivel" value={data.nivel} />
                <InfoRow icon={Tag} label="Categoría" value={data.categoria} />
                <InfoRow icon={AtSign} label="Usuario" value={data.usuario} />
                <InfoRow icon={UserCircle} label="Nombre" value={data.nombre} />
                <InfoRow icon={IdCard} label="Nickname" value={data.nickname} />
                <InfoRow icon={UserCircle} label="Apellido" value={data.apellido} />
            </div>
        ) : (
            <div className="rounded-xl bg-gray-50 p-6 text-center text-sm text-gray-600 ring-1 ring-black/5 dark:bg-gray-800 dark:text-gray-300 dark:ring-white/10">
                No se encontraron atributos para este usuario.
            </div>
        )
        }


        <div className="mt-6 text-center text-xs text-gray-400 dark:text-gray-500">
        © {new Date().getFullYear()} SumaqtAI — Lecturas que Florecen
        </div>
        </motion.div>
    </div>
    </>
    
    );

    return (
        <div className="max-w-2xl mx-auto mt-12 bg-white shadow-lg rounded-2xl border border-gray-100 p-6">
        <div className="flex items-center justify-between mb-4">
            <h1 className="text-2xl font-bold text-gray-900">
            Perfil del Usuario
            </h1>
            {data.categoria && (
            <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full uppercase">
                {data.categoria}
            </span>
            )}
        </div>

        <p className="text-sm text-gray-500 mb-6">
            Información general del usuario actual.
        </p>

        <div className="space-y-2">
            <InfoRow icon={Building2} label="UGEL" value={data.ugel} />
            <InfoRow icon={School} label="Institución" value={data.institucion} />
            <InfoRow icon={Layers} label="Nivel" value={data.nivel} />
            <InfoRow icon={Tag} label="Categoría" value={data.categoria} />
            <InfoRow icon={AtSign} label="Usuario" value={data.usuario} />
            <InfoRow icon={UserCircle} label="Nombre" value={data.nombre} />
            <InfoRow icon={IdCard} label="Nickname" value={data.nickname} />
            <InfoRow icon={UserCircle} label="Apellido" value={data.apellido} />
        </div>

        <div className="mt-6 text-center text-xs text-gray-400">
            © {new Date().getFullYear()} SumaqtAI — Lecturas que Florecen
        </div>
        </div>
    );

    return <>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <p><b>UGEL:</b> {JSON.stringify(currentuser.attributes['locale'])}</p>
        <p><b>Institución:</b> {JSON.stringify(currentuser.attributes['custom:Colegio'])}</p>
        <p><b>Nivel:</b> {JSON.stringify(currentuser.attributes['custom:Nivel'])}</p>
        <p><b>Categoria:</b> {JSON.stringify(currentuser.attributes['custom:categoria_usuario'])}</p>
        <p><b>usuario:</b> {JSON.stringify(currentuser.username)}</p>
        <p><b>Nombre:</b> {JSON.stringify(currentuser.attributes['name'])}</p>
        <p><b>Nickname:</b> {JSON.stringify(currentuser.attributes['nickname'])}</p>
        <p><b>Apellido:</b> {JSON.stringify(currentuser.attributes['family_name'])}</p>
        
    </>
    
}

